export default {
    origin: "Origin",
    destination: "Destination",
    date: "Date",
    dates: "Dates",
    microtrips: "Microtrips",
    selectOrigin: "Smart data for smarter destinations: select an origin to start",
    "Select a destination": "Select a destination",
    "Select a origin": "Select an origin",
    "Select a province": "Select a province",
    orDestination: "or destination",
    "Total trips": "Total trips",
    "In/Out trips": "In/Out trips",
    "In/In trips": "In/In trips",
    moreStats: "For more statistics, please visit",
    spain: "Spain",
    username: "Username",
    password: "Password",
    login: "Login",
    cancel: "Cancel",
    ok: "OK",
    help: "Left click to select an origin, right click to select a destination",
    "reset origin": "Remove origin",
    "reset destination": "Remove destination",
    flip: "Switch",
    accept: "OK",
    "info btn": "Technical note and methodology",
    "<1h": "Less than 1 hour",
    "1h<6h": "Between 1-6 h.",
    "6h<12h": "Between 7-12 h.",
    ">12h": "More than 12 h.",
    week: "Week",
    month: "Month",
    selectAverage: "Select an average",
    languages: "Language",
    country: "Country",
    "Select an average": "Select an average",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    "Roamers per day": "Roamers per day",
    from: "from",
    "Roamers per nationality": "Roamers per nationality",
    light: "Light mode",
    night: "Night mode",
    layout: "Layout",
    "Total trips per day": "Total trips per day",
    "Select an origin": "Select an origin",
    "Total trips per origin": "Trips per origin",
    "Visits per origin": "Visits per origin",
    trips: "trips",
    national: "National",
    international: "International",
    nationals: "Nationals",
    internationals: "Internationals",
    "Roamers per province": "Visits per province",
    //PDF
    period: "Period",
    report: "Report name",
    requested: "Requested by",
    geo_selection: "Geographical Selection",
    vis_reference: "Visualization Reference",
    location_type: "Location type",
    province: "Province",
    provinces: "provinces",
    hosting: "<span>Host / Hosting Area</span>",
    region: "Region",
    municipality: "Municipality",
    district: "District",
    dataset_parameters: "Dataset Parameters",
    main_metrics: "Main metrics",
    pop_res: "Population / Residents",
    total_uniques: "Total unique visitors",
    regulars: "Regulars",
    national_visitors: "National visitors",
    international_visitors: "International visitors",
    ranking_vs: "Ranking Vs other municipalities",
    same_period: "Same period from",
    all_metrics: "All metrics related to analyzed period or otherwise stated",
    selected_period: "Selected period",
    busiest_day: "Busiest Day",
    busiest_time: "Busiest Time",
    unique_visitors_act: "Unique visitors activity",
    visitors_day: "Visitors for the day",
    overnight_visitors: "Total overnight stays",
    avgStayN: "Average overnight in NIGHTS",
    by_length: "By length of stay",
    daytime_visitors: "Total visits",
    uniques_hour: "Unique visitors per hour",
    by_province: "By province of origin",
    by_country: "By country of origin",
    COM: "State",
    PRO: "Province",
    MUN: "Municipality",
    DISC: "District",
    SEC: "Section",
    all: "All",
    county: "County",
    counties: "communities",
    census: "Census defined",
    glossary: "Glossary",
    "1 Night": "1 Night",
    "2 Night": "2 Night",
    "3 Night": "3 Night",
    "More than 3 nights": "More than 3 nights",
    glos1: "Is the geographical area on which the data is offered, both at the report level and our other services. Each host is either a single province, state, municipality, or district, or a collection thereof.",
    glos2: "<span>Resident (also found as population)</span>: Individuals whose place of residence is located within the hosting area. For an individual to be considered a resident, they must have spent at least 15 consecutive nights (overnight stays) or 18 non-consecutive nights during the last 30 days within the host area. An overnight stay is such that the individual has the first stay of the day and the last stay of the previous day occuring within the same host area.",
    glos3: "<span>Regulars</span>: Individuals who are not residents of the host area and spend most of the weekdays' daytime within it. An individual is considered a regular if they are seen for at least 14 non-consecutive working days during the last 30 days on the host area and for at least 30 minutes each day they have been seen, between 06:00 and 22:00 Monday to Friday also within mentioned area.",
    glos4: "<span>Unique visitors</span>: Any individual who is not a resident nor a regular and has spent at least 30 minutes during a day in the host area. An individual having breakfast in the host, then traveling to an adjacent host, and then coming back for dinner at the host would count as one visitor.",
    glos5: "<i>Category 1</i>:<ul><li><span>National</span>: Individual with main residence within Spain. </li><li><span>International</span>: Individual with main residence outside Spain.</li></ul>",
    glos6: "<i>Category 2</i>:<ul><li><span>Hiker</span>: unique visitor who does not have any overnight stay within the host.<ul><li>Length of stay: <2 hours</li><li>Length of stay: 2-6 hours</li><li>Length of stay: 6-12 hours</li></ul></li></ul><ul><li><span>Tourist</span>: unique visitor with one or more overnight stays.<ul><li>Overnight stay 1 night</li><li>Overnight stay 2 nights</li><li>Weekender: tourist that has more than two overnight stays all of which occur exclusively on Friday and Saturday nights.</li><li>Overnight stay 3-6 nights</li><li>Overnight stay 7-13 nights</li><li>Overnight stay> 13 nights</li></ul></li></ul>",
    glos7: "<span>Total number of overnight stays</span>: number of tourists and weekenders multiplied by the number of overnight stays for each one.",
    glos8: "<span>Busiest time</span>: time of day with the highest number of unique visitors among all the hours of the week / month analyzed",
    glos9: "<span>Average stay national / international visitors</span>: average time of stay of unique national visitors, including for each individual the total time of stays in the host, not counting time of overnight stay. <ul><li>For national / international hikers</li><li>For national / international tourists</li></ul>",
    glos10: "<span>Crowdness (presence of tourists per hour)</span><ul><li>Totals</li><li>National / International</li><li>Maximum minimum</li></ul>",
    glos11: "<span>Rankings</span>: When the host is a province, ranking of the host relative to other provinces. Otherwise, ranking of the host relative to other hosts within the same province.",
    glos12: "<span>Busiest day</span>: day of the month / week analyzed where the largest number of unique visitors is registered.",
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    jun: "June",
    jul: "July",
    aug: "August",
    sep: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    "jan-19": "2019 Enero",
    "feb-19": "2019 Febrero",
    "mar-19": "2019 Marzo",
    "apr-19": "2019 Abril",
    "may-19": "2019 Mayo",
    "jun-19": "2019 Junio",
    "jul-19": "2019 Julio",
    "aug-19": "2019 Agosto",
    "sep-19": "2019 Septiembre",
    "oct-19": "2019 Octubre",
    "nov-19": "2019 Noviembre",
    "dec-19": "2019 Diciembre",
    "jan-20": "2020 Enero",
    "feb-20": "2020 Febrero",
    "mar-20": "2020 Marzo",
    "apr-20": "2020 Abril",
    "may-20": "2020 Mayo",
    "jun-20": "2020 Junio",
    "jul-20": "2020 Julio",
    "aug-20": "2020 Agosto",
    "sep-20": "2020 Septiembre",
    "oct-20": "2020 Octubre",
    "nov-20": "2020 Noviembre",
    "dec-20": "2020 Diciembre",
    "jan-21": "2021 Enero",
    "feb-21": "2021 Febrero",
    "mar-21": "2021 Marzo",
    "apr-21": "2021 Abril",
    avgStay: "Average stay in HOURS",
};
